module.exports = __webpack_public_path__ + "img/logo2.a214d6de.png";